<div class="qr-popup">
  <div class="qr-popup__header">
    <h2 class="qr-popup__title">{{description}}</h2>
    <button class="qr-popup__close" (click)="close()">
      <i class="material-icons">close</i>
    </button>
  </div>

  <mat-dialog-content>
    <div class="qr-popup__body">
      <mat-form-field *ngIf="tableSelectorEnabled" class="qr-popup__table-select" appearance="outline">
        <mat-label>Select Table</mat-label>
        <mat-select name="roleSelect"
                    (selectionChange)="addTableToAutologin($event.value)">
          <mat-optgroup [label]="'MAIN DINING'">
            <mat-option *ngFor="let table of tables" [value]="table.name">{{table.name}}</mat-option>
          </mat-optgroup>
          <mat-optgroup *ngFor="let layout of currentUser.orgSettings.additionalLayouts | keyvalue"
                        [label]="layout.key">
            <mat-option *ngFor="let table of layout.value"
                        [value]="table.name">{{table.name.split(layout.key + ' - ')[1].toLocaleLowerCase()}}</mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>

      <div class="qr-popup__code-container">
        <div class="qr-popup__code-frame">
          <qrcode #qrcode
                  [qrdata]="qrUrl"
                  [allowEmptyString]="true"
                  [attr.ariaLabel]="'QR Code image with the following content...'"
                  [cssClass]="'center'"
                  [colorDark]="colorDark"
                  [colorLight]="colorLight"
                  [elementType]="'canvas'"
                  [errorCorrectionLevel]="'M'"
                  [attr.imageSrc]="imageSrc ? imageSrc : './assets/default-logo.png'"
                  [attr.imageHeight]="height"
                  [attr.imageWidth]="width"
                  [margin]="4"
                  [scale]="1"
                  [title]="title"
                  [width]="width"
          ></qrcode>
        </div>
        <p class="qr-popup__hint">Scan with your phone camera to pay</p>
      </div>

      <button *ngIf="downloadButtonEnabled" class="qr-popup__download" (click)="saveAsImage(qrcode)">
        <i class="material-icons">download</i>
        Download QR Code
      </button>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button class="qr-popup__done" (click)="close()">{{ 'button.finish' | translate }}</button>
  </mat-dialog-actions>
</div>
